import React from 'react';
import AppLayout from '../../../component/appLayout';
import WorkLoad from '../../../component/reportWorkload';

const WorkLoadPage = () => {
  return (
    <>
      <AppLayout>
        <WorkLoad />
      </AppLayout>
    </>
  );
};

export default WorkLoadPage;
